// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"331":"9a1db30a","589":"fb0e2abd","928":"086452a1"}[chunkId] + ".chunk.css";
};